<template>
  <div
    class="mobile-header d-block d-xl-none"
    :style="[ globalStore.showBanner ? { marginTop: globalStore.bannerHeight + 'px' } : '' ]"
  >
    <a href="/" class="mobile-header__logo-link">
      <img src="/images/village-guide-white-logo.png" alt="Village Guide" loading="lazy" >
    </a>
    <a href="/my-saved-list" v-show="isUserLoggedIn" class="mobile-header__profile"><img src="/images/profile.png" loading="lazy" ></a>
    <button
      type="button"
      class="mobile-header__search"
      :class="{ 'mobile-header__search--close': showMobileSearch }"
      @click.prevent="toggleMobileSearch"
    >
      <i class="icon icon--search" :class="{ 'icon--cross': showMobileSearch }"></i>
      <span class="sr-only">Search</span>
    </button>
    <button
      type="button"
      class="mobile-header__hamburger"
      :class="{ 'mobile-header__hamburger--close': showMobileMenu }"
      @click.prevent="toggleMobileMenu"
    >
      <i class="icon icon--hamburger" :class="{ 'icon--cross': showMobileMenu }"></i>
      <span class="sr-only">Mobile menu</span>
    </button>

    <transition name="slide-fade-top">
      <div
        class="search"
        ref="searchHeader"
        v-cloak
        v-if="showMobileSearch"
        :style="[ globalStore.showBanner ? { top: (globalStore.bannerHeight + 100) + 'px' } : '' ]"
      >
        <form action="/search" method="GET" class="search__form">
          <input type="text" placeholder="Search for ..." name="keyword" class="search__input">
          <button type="submit" class="search__button">
            <i class="icon icon--search icon--search-green"></i>
            <span class="sr-only">Search</span>
          </button>
        </form>
      </div>
    </transition>
    <div
      class="mobile-menu__background"
      v-if="showMobileMenu"
      v-cloak
      :style="[ globalStore.showBanner ? { top: (globalStore.bannerHeight + 100) + 'px' } : '' ]"
    ></div>
    <transition name="slide-fade-right">
      <div
        class="mobile-menu"
        ref="mobileMenu"
        v-cloak
        v-if="showMobileMenu"
        :style="[ globalStore.showBanner ? { top: (globalStore.bannerHeight + 100) + 'px' } : '' ]">
        <div class="mobile-menu__wrapper">
          <ul class="mobile-menu__list">
            <li
              class="mobile-menu__item mobile-menu__item--level1"
              :class="{ 'mobile-menu__item--level1-active': levelOneMenuId === menuItemKey }"
              v-for="(menuItem, menuItemKey) in menuList"
            >
              <a
                :href="menuItem.children.length > 0 ? '#' : menuItem.link"
                class="mobile-menu__link mobile-menu__link--level1"
                v-on="menuItem.children.length > 0 ? { click: () => toggleLevel1Menu(menuItemKey) } : {}"
                :class="{ 'mobile-menu__link--level1-active': levelOneMenuId === menuItemKey }"
                v-show="(menuItem.name === 'My Account' && isUserLoggedIn) || menuItem.name !== 'My Account'"
              >
                {{ menuItem.name }}
                <i v-if="menuItem.children.length > 0" class="icon" :class="{'icon--minus': levelOneMenuId === menuItemKey,  'icon--plus': levelOneMenuId !== menuItemKey}"></i>
              </a>
              <transition @enter="expanding" @leave="collapsing" v-if="menuItem.regions">
                <ul class="mobile-menu__list mobile-menu__list--level2-region mobile-menu__list--region" v-cloak v-if="levelOneMenuId === menuItemKey">
                  <li class="mobile-menu__item mobile-menu__item--region" v-for="region in regions">
                    <a :href="`${menuItem.link}/${region.url}`" class="mobile-menu__link mobile-menu__link--region">{{ region.value }}</a>
                  </li>
                </ul>
              </transition>
              <transition @enter="expanding" @leave="collapsing" v-if="menuItem.children">
                <ul class="mobile-menu__list mobile-menu__list--level2" v-cloak v-if="levelOneMenuId === menuItemKey">
                  <li class="mobile-menu__item mobile-menu__item--level2" v-for="(levelTwoItem, levelTwoKey) in menuItem.children">
                    <a
                      :href="levelTwoItem.link"
                      @click.prevent="toggleLevel2Menu(levelTwoKey, levelTwoItem.link)"
                      v-if="!levelTwoItem.regions"
                      class="mobile-menu__link mobile-menu__link--level2"
                      :class="{ 'mobile-menu__list--level2-active': levelOneMenuId === levelTwoKey, 'mobile-menu__link--account': levelTwoItem.isMyAccount }"
                    >
                      <i class="icon icon--heart-selected" v-show="levelTwoItem.name === 'My Saved List'"></i>
                      <i class="icon icon--star" v-show="levelTwoItem.name === 'Email Preferences'"></i>
                      {{ levelTwoItem.name }}
                      <i
                        v-if="levelTwoItem.children || levelTwoItem.regions"
                        class="icon"
                        :class="{'icon--minus': levelTwoMenuId === levelTwoKey,  'icon--plus': levelTwoMenuId !== levelTwoKey}"
                      ></i>
                    </a>

                    <a
                      href="#"
                      v-if="levelTwoItem.regions"
                      class="mobile-menu__link mobile-menu__link--level2"
                      @click.prevent="toggleLevel2Menu(levelTwoKey, '#')"
                      :class="{ 'mobile-menu__list--level2-active': levelOneMenuId === levelTwoKey }"
                    >
                      {{ levelTwoItem.name }}
                      <i
                        v-if="levelTwoItem.children || levelTwoItem.regions"
                        class="icon"
                        :class="{'icon--minus': levelTwoMenuId === levelTwoKey,  'icon--plus': levelTwoMenuId !== levelTwoKey}"
                      ></i>
                    </a>

                    <transition @enter="expanding" @leave="collapsing" v-if="levelTwoItem.regions">
                      <ul class="mobile-menu__list mobile-menu__list--region" v-cloak v-if="levelTwoMenuId === levelTwoKey"  data-level="2">
                        <li class="mobile-menu__item mobile-menu__item--region" v-for="region in regions">
                          <a :href="`${levelTwoItem.link}/${region.url}`" class="mobile-menu__link mobile-menu__link--region">{{ region.value }}</a>
                        </li>
                      </ul>
                    </transition>

                    <!-- 3rd level menu start -->
                    <transition @enter="expanding" @leave="collapsing" v-if="levelTwoItem.children">
                      <ul
                        class="mobile-menu__list mobile-menu__list--region"
                        v-cloak v-if="levelTwoMenuId === levelTwoKey"  data-level="2"
                      >
                        <li class="mobile-menu__item mobile-menu__item--level3" v-for="levelThreeItem in levelTwoItem.children">
                          <a
                            :href="levelThreeItem.link"
                            class="mobile-menu__link mobile-menu__link--level3"
                          > {{ levelThreeItem.name }}</a>
                        </li>
                      </ul>
                    </transition>
                  </li>
                </ul>
              </transition>

            </li>
          </ul>
          <button
            class="mobile-menu__login"
            @click="globalStore.setModal({name: 'loginButtonModal', showFooter: true})"
            v-show="!isUserLoggedIn"
          >
            Login
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import useGlobalStore from './../../store/globalStore'

const props = defineProps({
  isUserLoggedIn: Boolean,
})

let showMobileMenu = ref(false);
let showMobileSearch = ref(false);
let levelOneMenuId = ref(null);
let levelTwoMenuId = ref(null);
let searchHeader = ref(null);
let mobileMenu = ref(null);
const globalStore = useGlobalStore()

const regions = ref([
  {
    'value': 'All Regions',
    'url': ''
  },
  {
    'value': 'Manawatu / Wanganui',
    'url': 'manawatu-wanganui',
  },
  {
    'value': 'Northland',
    'url': 'northland',
  },
  {
    'value': 'Wellington',
    'url': 'wellington',
  },
  {
    'value': 'Auckland',
    'url': 'auckland',
  },
  {
    'value': 'Nelson / Tasman',
    'url': 'nelson-tasman',
  },
  {
    'value': 'Waikato',
    'url': 'waikato',
  },
  {
    'value': 'Marlborough',
    'url': 'marlborough',
  },
  {
    'value': 'Bay of Plenty',
    'url': 'bay-of-plenty',
  },
  {
    'value': 'West Coast',
    'url': 'west-coast',
  },
  {
    'value': 'Gisborne',
    'url': 'gisborne',
  },
  {
    'value': 'Canterbury',
    'url': 'canterbury',
  },
  {
    'value': 'Hawke\'s Bay',
    'url': 'hawkes-bay',
  },
  {
    'value': 'Otago',
    'url': 'otago',
  },
  {
    'value': 'Taranaki',
    'url': 'taranaki',
  },
  {
    'value': 'Southland',
    'url': 'southland'
  },
]);

let menuList = ref([
  {
    'name': 'Retirement villages',
    'link': '/retirement-villages',
    'regions': true,
    'children': [
      {
        'name': 'Retirement village costs',
        'link': '/resource-centre/the-costs-of-living-in-a-retirement-village',
      },
      {
        'name': 'What is a licence to occupy',
        'link': '/resource-centre/what-is-a-licence-to-occupy',
      },
      {
        'name': 'The benefits of living in a retirement village',
        'link': '/resource-centre/10-benefits-of-living-in-a-retirement-village',
      },
      {
        'name': 'Frequently asked questions',
        'link': '/retirement-village-faqs',
      },
    ],
  },
  {
    'name': 'Homes for sale',
    'link': '/available-properties',
    'regions': true,
    'children': [
      {
        'name': 'Villas',
        'link': '/available-properties?home-types=1',
      },
      {
        'name': 'Townhouses',
        'link': '/available-properties?home-types=2',
      },
      {
        'name': 'Apartments',
        'link': '/available-properties?home-types=3',
      },
      {
        'name': 'Serviced Apartments',
        'link': '/available-properties?home-types=4',
      },
      {
        'name': 'Cottages',
        'link': '/available-properties?home-types=5',
      },
      {
        'name': 'Units',
        'link': '/available-properties?home-types=6',
      },
    ],
  },
  {
    'name': 'Rest homes',
    'link': '/rest-homes',
    'regions': true,
    'children': [
      {
        'name': 'Step-by-step guide',
        'link': '/resource-centre/care-home-resources',
      },
      {
        'name': 'Rest home costs',
        'link': '/resource-centre/care-home-resources/rest-home-subsidy',
      },
      {
        'name': 'Needs assessments',
        'link': '/resource-centre/care-home-resources/what-is-a-needs-assessment',
      },
      {
        'name': 'Frequently asked questions',
        'link': '/rest-home-faqs',
      },
    ],
  },
  {
    'name': 'Open days & events',
    'link': '/retirement-villages/open-days',
    'children': [],
  },
  {
    'name': 'Living options',
    'link': '#',
    'children': [
      {
        'name': 'Independent Living',
        'link': '/independent-living',
      },
      {
        'name': 'Assisted Living',
        'link': '/assisted-living',
      },
      {
        'name': 'Rest Home Care',
        'link': '/rest-home-care',
      },
      {
        'name': 'Hospital Care',
        'link': '/hospital-care',
      },
      {
        'name': 'Dementia Care',
        'link': '/dementia-care',
      },
      {
        'name': 'Respite Care',
        'link': '/respite-care',
      },
      {
        'name': 'Day Care',
        'link': '/day-care',
      },
    ],
  },
  {
    'name': 'Resource centre',
    'link': '#',
    'children': [
      {
        'name': 'Retirement Village Advice & Guides',
        'link': '/resource-centre/retirement-villages',
      },
      {
        'name': 'Rest Home Advice & Guides',
        'link': '/resource-centre/care-home-resources',
      },
      {
        'name': 'Video Knowledge Centre',
        'link': '/resource-centre/videos',
      },
    ],
  }
]);

if (props.isUserLoggedIn) {
  menuList.value.push({
    'name': 'My account',
    'children': [
      {
        'name': 'My Saved List',
        'link': '/my-saved-list',
        'isMyAccount': true
      },
      {
        'name': 'Email Preferences',
        'link': '/email-preferences',
        'isMyAccount': true
      },
      {
        'name': 'Profile',
        'link': '/profile',
        'isMyAccount': true
      },
      {
        'name': 'Password',
        'link': '/password-change',
        'isMyAccount': true
      },
      {
        'name': 'Logout',
        'link': '/logout',
        'isMyAccount': true
      }
    ]
  });
}
const toggleMobileMenu = () => {
  showMobileMenu.value = !showMobileMenu.value;
  showMobileSearch.value = false;
  levelOneMenuId.value = null;
  levelTwoMenuId.value = null;

  if(showMobileMenu.value) {
    document.body.classList.add('stop-scrolling');
  } else {
    document.body.classList.remove('stop-scrolling');
  }
};

const toggleMobileSearch = () => {
  showMobileSearch.value = !showMobileSearch.value;
  showMobileMenu.value = false;
};

const toggleLevel1Menu = (id) => {
  if (levelOneMenuId.value === id) {
    levelOneMenuId.value = null;
  } else {
    levelOneMenuId.value = id;
  }
  levelTwoMenuId.value = null;
};

const toggleLevel2Menu = (id, link) => {
  if (link !== '#') {
    window.location.href = link;
  }

  if (levelTwoMenuId.value === id) {
    levelTwoMenuId.value = null;
  } else {
    levelTwoMenuId.value = id;
  }
};

const expanding = (el) => {
  const height = el.scrollHeight;
  setHeightLevel2Menu(el, 'expand');
  el.style.height = `${height}px`;
};

const collapsing = (el) => {
  el.style.height = '0px';
  el.style.opacity = '0';
  setHeightLevel2Menu(el, 'collapse');
};

const setHeightLevel2Menu = (el, action) => {
  const level = parseInt(el.dataset.level, 10);
  if (level === 2) {
    el.parentNode.parentNode.style.height = 'auto';
  }
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

const handleScroll = (event) => {
  const top = window.pageYOffset || document.documentElement.scrollTop;
  const menuElement = mobileMenu.value;
  const searchHeaderElement = searchHeader.value;

  if (top <= 100) {
    if (menuElement !== null) {
      const menuTop = 100 - parseInt(top, 10) - 1;
      menuElement.style.top = `${menuTop}px`;
    }

    if (searchHeaderElement !== null) {
      const searchTop = 100 - parseInt(top, 10) - 1;
      searchHeaderElement.style.top = `${searchTop}px`;
    }
  } else {
    if (menuElement !== null) {
      menuElement.style.top = `0`;
    }

    if (searchHeaderElement !== null) {
      searchHeaderElement.style.top = `0`;
    }
  }
};
// hide the mobile search when scrolling
showMobileSearch.value = false;
</script>
